export default __webpack_public_path__ + "strongher-screens_small.279427a4.png";